export enum ADDRESS_BOOK_PERMISSIONS {
  ADDRESS_BOOK_VIEW = 'SHIPPING_ADDRESSBOOKVIEW',
  ADDRESS_BOOK_WRITE = 'SHIPPING_ADDRESSBOOKWRITE',
}
